import * as tokens from '@utmost.co/utmost-design-tokens';
import { Components } from '../../../styles';

export const paginationTheme = {
  MuiPaginationItem: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: tokens.colorSecondaryContainer,
          color: tokens.colorOnSecondaryContainer,
          '&.Mui-disabled': {
            color: tokens.stateOnSurfaceDisabledContentStateLayerColor,
            backgroundColor: tokens.stateOnSurfaceDisabledContainerStateLayerColor
          }
        }
      }
    }
  }
} satisfies Components;
